import { useEffect, useState } from 'react';
import { IconMoreVerticalDots, DocumentationIcon } from '../../../../components/buttons/IconButtons';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import TableFunction from '../../../../components/table/TableFunction';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SEARCH_MODEL } from '../../../../components/table/Model/TableModel';
import {SimpleSearchWithId} from "../../../../reduxToolkit/Search/SearchApi";
import {VEHICLE_LIST_MODEL} from "../Model/Models";
import {VIEW_TYPE} from "../../../../enums/ViewType";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const VehicleSectionApp = ({ contractorId, model, supplierId }) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // Controls visibility of the documentation modal
    const [selected, setSelected] = useState(null); // Stores currently selected vehicle for documentation
    const [selectedList, setSelectedList] = useState([]); // Stores selected rows from the table
    const [searchElement, setSearchElement] = useState(''); // Search input text
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false); // Flag to use simple search mode
    const searchId = 'txt_vsa_search_documentation_vehicle'; // Search input DOM ID
    const [results, setResults] = useState(); // Stores API results for vehicles
    const { t } = useTranslation();

    // Render dropdown menu for each vehicle row
    const getActionsButtons = (item, index) => {
        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
                icon={<IconMoreVerticalDots />}
            >
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t('documentation')}
                    icon={<DocumentationIcon />}
                    click={() => {
                        setSelected(item);
                        setShowModal(true);
                    }}
                />
            </DropDownMenuProfile>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model, key: searchElement, userId: contractorId || supplierId });
        dispatch(SimpleSearchWithId({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success === true) {
                setData(data);
            }
        });
    };

    // Table logic: pagination, selection, menu state
    const { handleMenuToggle, handleClose, openMenu, page, rowsPerPage, pagination } = TableFunction({
        selectedList,
        setSelectedList,
        labelRowsPerPage: 'vehicles_per_page',
        data: results,
        hasContainer:true,
        fixedPagination:false,
        view: VIEW_TYPE.GRID.name,
        searchElement, //New
        getData//New
    });

    const setData = (data) => {
        setResults({content: data?.content?.map(e => VEHICLE_LIST_MODEL.toSet(e)), totalElements: data?.totalElements});
    };

    return {
        t,
        showModal,
        setShowModal,
        selected,
        setSelected,
        searchId,
        setResults,
        results,
        searchElement,
        setSearchElement,
        setSearch,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        setData,
        pagination,
        getActionsButtons,
    };
};

export default VehicleSectionApp;
